import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './MobileNavigation.module.css';
import { ChevronDown } from 'lucide-react';

const MobileNavigation = ({ inHeader = false }) => {
  const navigate = useNavigate();
  const [audioDropdownOpen, setAudioDropdownOpen] = useState(false);
  const [readingDropdownOpen, setReadingDropdownOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [isScrolled, setIsScrolled] = useState(false);
  const navRef = useRef(null);

  const toggleAudioDropdown = () => {
    setAudioDropdownOpen(!audioDropdownOpen);
    setReadingDropdownOpen(false);
  };

  const toggleReadingDropdown = () => {
    setReadingDropdownOpen(!readingDropdownOpen);
    setAudioDropdownOpen(false);
  };

  const navigateTo = (path) => {
    navigate(path);
    setAudioDropdownOpen(false);
    setReadingDropdownOpen(false);
  };

  // Handle click outside to close dropdowns
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navRef.current && !navRef.current.contains(event.target)) {
        setAudioDropdownOpen(false);
        setReadingDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('touchstart', handleClickOutside);
    
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, []);

  // Handle scroll to hide/show navigation and toggle background
  useEffect(() => {
    const controlNavbar = () => {
      const scrollY = window.scrollY;
      
      if (scrollY > lastScrollY && scrollY > 100) {
        // Scrolling down & past threshold - hide nav
        setIsVisible(false);
      } else {
        // Scrolling up - show nav
        setIsVisible(true);
      }
      
      // Toggle background like header when scrolled past 50px
      setIsScrolled(scrollY > 50);

      setLastScrollY(scrollY);
    };

    window.addEventListener('scroll', controlNavbar);
    
    return () => {
      window.removeEventListener('scroll', controlNavbar);
    };
  }, [lastScrollY]);

  const containerClassName = inHeader ? styles.mobileNavEmbedded : styles.mobileNavContainer;

  return (
    <div 
      ref={navRef}
      className={`${containerClassName} ${isVisible ? styles.visible : styles.hidden}`}
    >
      <div className={`${styles.navRow} ${isScrolled ? styles.scrolled : ''}`}>
        <div className={styles.navItem}>
          <button
            className={styles.navButton}
            onClick={toggleAudioDropdown}
          >
            Audios <ChevronDown size={14} />
          </button>
          {audioDropdownOpen && (
            <div className={styles.dropdown}>
              <div onClick={() => navigateTo('/shortstories/hindi')} className={styles.dropdownItem}>
                Hindi
              </div>
              <div onClick={() => navigateTo('/shortstory/english')} className={styles.dropdownItem}>
                English
              </div>
              <div onClick={() => navigateTo('/shortstory-garhwali/garhwali')} className={styles.dropdownItem}>
                Garhwali
              </div>
            </div>
          )}
        </div>

        <div className={styles.navItem}>
          <button
            className={styles.navButton}
            onClick={toggleReadingDropdown}
          >
            Reading <ChevronDown size={14} />
          </button>
          {readingDropdownOpen && (
            <div className={styles.dropdown}>
              <div onClick={() => navigateTo('/hindi-reading')} className={styles.dropdownItem}>
                Hindi
              </div>
              <div onClick={() => navigateTo('/garhwali-reading')} className={styles.dropdownItem}>
                Garhwali
              </div>
              <div onClick={() => navigateTo('/reading')} className={styles.dropdownItem}>
                English
              </div>
            </div>
          )}
        </div>

        <div className={styles.navItem}>
          <button
            className={styles.navButton}
            onClick={() => navigateTo('/video')}
          >
            Videos
          </button>
        </div>
      </div>
    </div>
  );
};

export default MobileNavigation;